import { t } from "i18next";
import React from "react";

import ApplicationLayout from "components/layout/ApplicationLayout";
import { MY_SETTINGS_ROUTE } from "components/router/Routes";
import { TenantSettingsSubpage } from "components/settings/views/my-settings/tenant-settings/TenantSettingsSubpage";
import { UserSettingsSubpage } from "components/settings/views/my-settings/user-settings/UserSettingsSubpage";
import { hasTenantCookie } from "services/tenants/tenantCookieService";

export const MySettingsView = () => {
    return (
        <ApplicationLayout
            viewTitle={t("Routes.mySettings")}
            view={hasTenantCookie() ? <TenantSettingsSubpage /> : <UserSettingsSubpage />}
            mainRoute={MY_SETTINGS_ROUTE}
        />
    );
};
